import axios from 'axios'

import { GetServerSidePropsContext } from 'next'

import { Response_WorkDetailResponseBody } from '@/api/@types'
import { WebView } from '@/components/common/Layout'
import { OGP } from '@/components/common/Util'

import { WorkDetails } from './workDetails'

interface Props {
  work: Response_WorkDetailResponseBody
  projectName: string
}

const WorkDetailsRoute: React.FC<Props> = ({ work, projectName }) => {
  const season = work?.projects
    ?.find(p => p.name === projectName)
    ?.seasons?.find(() => true)
  return (
    <WebView>
      <OGP
        title={work?.name ?? ''}
        description={season?.description ?? ''}
        imgUrl={season?.ogpImageUrl ?? ''}
        imgWidth={1200}
        imgHeight={630}
        url={`https://www.bump.studio/work/${work?.id ?? ''}`}
      />
      <WorkDetails />
    </WebView>
  )
}

export default WorkDetailsRoute

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const res = await axios.get<Response_WorkDetailResponseBody>(
    `${
      process.env.NEXT_PUBLIC_API_BASE_URL ||
      'https://dev-backend.bump.studio/api/v1/'
    }/works/${context.query.uuid}`
  )
  const work = await res.data
  const projectName =
    context.query.projectName === 'making' ? '制作裏側' : '本編'

  // それをpropsに入れて、オブジェクトとして返す
  return { props: { work, projectName } }
}
